import { Button } from 'antd';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  overflow-x: auto;
  width: 100%;

  .ant-checkbox-group {
    display: flex;
    flex-direction: column;
    .ant-checkbox-wrapper {
      margin: 0;
    }
  }

  @media (min-width: ${({ theme }) => theme.mediaQueries.md}) {
    flex-direction: row;
    flex-wrap: nowrap;
    overflow-x: auto;
    .ant-select,
    .ant-picker {
      min-width: 100px;
    }
  }
`;

export const ClearSearch = styled(Button)`
  margin-top: 5px;
`;

export const CheckboxWrapper = styled.div`
  padding: 8px 12px;
`;
